export enum RentrapStorageKey {
  PACKAGING = "F",
  SPOT = "JY1",
  GOOD = "JY2",
  DEALER = "JY3",
  ONLINE = "JY4",
  CARREFOUR = "JY5",
  MEGA_PXMART = "JY6",
  DECATHLON = "JY7",
  POYA = "JY8",
  PX_MART = "JY9",
  CROSS_BORDER = "JY10",
  URMART = "JY11",
  BAD = "JY12",
}

export enum TcatStorageKey {
  GOOD = "GOOD",
  BAD = "BAD",
}

// data
const rentrapStorageData = [
  { key: RentrapStorageKey.PACKAGING, name: "耗材 包材" },
  { key: RentrapStorageKey.SPOT, name: "即期倉" },
  { key: RentrapStorageKey.GOOD, name: "良品倉" },
  { key: RentrapStorageKey.DEALER, name: "經銷倉" },
  { key: RentrapStorageKey.ONLINE, name: "線上倉" },
  { key: RentrapStorageKey.CARREFOUR, name: "家樂福倉" },
  { key: RentrapStorageKey.MEGA_PXMART, name: "大潤發倉" },
  { key: RentrapStorageKey.DECATHLON, name: "迪卡儂倉" },
  { key: RentrapStorageKey.POYA, name: "寶雅倉" },
  { key: RentrapStorageKey.PX_MART, name: "全聯倉" },
  { key: RentrapStorageKey.CROSS_BORDER, name: "跨境倉" },
  { key: RentrapStorageKey.URMART, name: "UrMart 倉" },
  { key: RentrapStorageKey.BAD, name: "壞品倉" },
] as const;

const tcatStorageData = [
  { key: TcatStorageKey.GOOD, name: "良品倉" },
  { key: TcatStorageKey.BAD, name: "壞品倉" },
] as const;

// options
export const storageTypeOptions = rentrapStorageData.map(({ key, name }) => ({ key, name, value: key }));
export const TcatStorageTypeOptions = tcatStorageData.map(({ key, name }) => ({ key, name, value: key }));

export enum WarehouseType {
  INTERNAL_WAREHOUSE = 1,
  EXTERNAL_WAREHOUSE = 2,
}
